import React from 'react';

const SourceSelector = props => {

    return <div onClick={() => props.editSourceSelector(props.sourceSelector)}>
        <span>{props.sourceSelector.name}</span>
    </div>
}

export default SourceSelector;